var React = require('react');

function E3 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"E3"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"50.79 47.85 47.59 27.31 21.41 31.38 17.72 52.99 50.79 47.85","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("polygon",{"points":"23.24 21 49.23 20.79 49.06 0 23.07 0.21 0 0.39 0.47 59.63 0.64 80.42 23.71 80.24 49.7 80.03 49.53 59.24 31.94 59.38 23.54 59.45 23.24 21","fill":"#73c9bd","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

E3.defaultProps = {"viewBox":"0 0 50.79 80.42"};

module.exports = E3;

E3.default = E3;
